import React, { useEffect, useState } from "react";
import { FaCheckSquare } from "react-icons/fa";
import { Question } from "../types";
import { deleteSurveyQuestion } from "../Firebase/utils";
import { deleteQuestion } from "../store/features/CreateSurveySlice";
import { useAppDispatch, useAppSelector } from "../store/store";
import { updateQuestionResponse } from "../store/features/CompleteSurveySlice";
import QuestionResponseContainer from "./QuestionResponseContainer";

interface MultipleChoiceOptionsPreviewDisplayProps {
    question: Question,
    questionText: string;
    options: string[];
}

export default (props: MultipleChoiceOptionsPreviewDisplayProps) => {



    const { question, questionText, options } = props;
    const [ selectedOption, setSelectedOption ] = useState<string>('');
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const [ modalOpen, setModalOpen ] = useState<boolean>(false);

    useEffect(() => {
        dispatch(updateQuestionResponse({questionId:question.id, response:selectedOption}))
    }, [selectedOption]);

    const handleSelection = () => {

    }

    const submitResponse = () => {
        try{

        }catch(err){
            alert(err);
        }
    }

    return (
        <QuestionResponseContainer question={question}>
            <div className="flex flex-col gap-4">
                <ul className="flex flex-col justify-center gap-5">
                    {options.map((option: string) => {
                        return (
                            <button onClick={ () => {setSelectedOption(option)}} key={option} className={`grid grid-cols-12 md:flex gap-2 text-xl ${selectedOption === option ? 'text-[#3da8e2]' : 'text-stone-400'}`}>
                                <FaCheckSquare className='col-span-1 text-3xl'/>
                                <p className='col-span-11 flex justify-start text-start pl-2'>{option}</p>
                            </button>
                        );
                    })}
                </ul>
            </div>
        </QuestionResponseContainer>
    )
}